











import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Module = namespace('environment');

@Component
export default class Footer extends Vue {
    @Module.Getter public environment: string | null;
    @Module.Getter public version: string | null;
}
